import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';
import { Card, Container, Row, Col } from 'react-bootstrap';
import Pagination from '../../components/Pagination';
import GET_ARTICLES from '../../graphql/queries/requests/getArticles';
import { useTranslation } from 'react-i18next';
import './index.scss';
import CardSkeleton from '../../components/Table/components/CardSkeleton'

const AllArticles = () => {
  const { t } = useTranslation();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [page, setPage] = useState(0);
  const [totalArticles, setTotalArticles] = useState(0);
  const articlesPerPage = 6;
  
  const { loading: queryLoading, error, data } = useQuery(GET_ARTICLES, { variables: {page: page} });

  useEffect(() => {
    if (data) {
      setArticles(data?.articles.data);
      setTotalArticles(data?.articles.count);
      setLoading(false);
    }
  }, [data]);

  const truncateContent = (content, maxLength) => {
    if (!content) return "";

    let strippedContent = "";

    if (typeof document !== "undefined") {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = content;

      // Join top-level child nodes with a space to preserve separation between block elements
      const parts = Array.from(tempDiv.childNodes)
        .map(node => (node.textContent || '').trim())
        .filter(Boolean);

      strippedContent = parts.join(' ').replace(/\s+/g, ' ').trim();
    } else {
      // SSR fallback: strip tags and decode common entity for basic safety
      strippedContent = content
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    if (strippedContent.length <= maxLength) return strippedContent;

    // Truncate without breaking the last word if possible
    let cut = strippedContent.substring(0, maxLength);
    const lastSpace = cut.lastIndexOf(' ');
    if (lastSpace > 0) cut = cut.substring(0, lastSpace);

    return cut + "...";
  };

  if (error) {
    return <div className="text-center text-danger mx-auto">{t('allArticles.errorMessage')}</div>;
  }

  return (
    <Container className="all-articles-container">

      {queryLoading || loading ? (
        <CardSkeleton count={articlesPerPage} aspectRatio="portrait" />
      ) : (
        <Row>
          {articles.map((article) => (
            <Col key={article.id} md={6} lg={4} className="mb-4">
              <Card className="h-100 article-card">
                <Card.Body className="d-flex flex-column">
                  <Card.Title>{article.title}</Card.Title>
                  <Card.Text>
                    {truncateContent(article.body?.value, 150)}
                  </Card.Text>
                  <Link 
                    to={`/news/single-view/${article.id}`} 
                    className="mt-auto btn primary-blue"
                  >
                    {t('allArticles.readMore')}
                  </Link>
                </Card.Body>
                <Card.Footer>
                  <small className="text-muted">{t('allArticles.created')} {new Date(article.created).toLocaleDateString()}</small>
                </Card.Footer>
              </Card>
            </Col>
          ))}
          <div className="d-flex justify-content-center">
              <Pagination 
                total={totalArticles}
                page={page}
                pageLimit={articlesPerPage}
                setPage={setPage}
                />
          </div>
        </Row>
      )}
    </Container>
  );
};

export default AllArticles;